module.exports = __webpack_public_path__ + "assets/c316c11964eea66476c4435e379772dc.mp3";